import React, { Component, Fragment, useState } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import Payment from "../payment/addEditPayment";
import { Modal } from "react-bootstrap";
import { float, getCompanyId } from "../../../util/customMethods";
import ReactSelect from "../../../components/utilComponents/tmSlimSelect/reactSelect";
import { calculateLaborCharge } from "../../../util/customMethods";
import { store } from "../../../store/configureStore";
import LineItems from "./LineItems";
const EstimateModal = ({
  show,
  onClose,
  onSubmit,
  ratePlanData,
  pickupToDropoffTime,
  estimatedLabourCharge,
}) => {
  const [estimateValue, setEstimateValue] = useState("");
  const [hourlyCharge, setHourlyCharge] = useState(0);

  const handleValueChange = (e) => {
    const inputValue = e.target.value;
    setEstimateValue(inputValue);

    const pickupToDropoffHours = Math.max(
      0,
      Number(pickupToDropoffTime || 0) / 60
    );
    const inputHours = Math.max(0, Number(inputValue || 0));
    const totalHours = inputHours + pickupToDropoffHours;

    const calculatedCharge = calculateLaborCharge(ratePlanData, totalHours);
    setHourlyCharge(calculatedCharge);
  };

  return (
    <Modal show={show} centered>
      <div className="modal-content p-3">
        <h4 className="mb-3">Estimate remaining Hours</h4>

        <div className="form-group mb-3">
          <label className="form-label">
            Elapsed Time: {pickupToDropoffTime || 0} minutes
          </label>
          <label className="d-block">
            Current Estimated Charge: ${estimatedLabourCharge?.toFixed(2) || '0.00'}
          </label>
          {hourlyCharge > 0 && (
            <label className="d-block fw-bold text-primary">
              New Estimated Charge: ${hourlyCharge.toFixed(2)}
            </label>
          )}
        </div>

        <div className="form-group mb-4">
          <label className="form-label">Additional Estimated Hours:</label>
          <input
            type="number"
            className="form-control"
            value={estimateValue}
            onChange={handleValueChange}
            min="0"
            step="0.5"
          />
        </div>

        <div className="text-center">
          <button className="btn btn-secondary me-2" onClick={onClose}>
            Close
          </button>
          <button
            className="btn btn-primary"
            onClick={() => onSubmit({ estimateValue, hourlyCharge })}
            disabled={!estimateValue || hourlyCharge <= 0}
          >
            Submit
          </button>
        </div>
      </div>
    </Modal>
  );
};

const ConfirmModal = ({ show, onClose, onConfirm }) => (
  <Modal show={show} centered>
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title">Confirm Payment</h5>
      </div>
      <div className="modal-body">
        <p>Are you sure you want to confirm this payment?</p>
      </div>
      <div className="modal-footer">
        <button className="btn btn-secondary" onClick={onClose}>
          Cancel
        </button>
        <button className="btn btn-primary" onClick={onConfirm}>
          Confirm
        </button>
      </div>
    </div>
  </Modal>
);

const CancelModal = ({ show, onClose, onCancel }) => (
  <Modal show={show} centered>
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title">Cancel Payment</h5>
      </div>
      <div className="modal-body">
        <p>Are you sure you want to cancel this payment?</p>
      </div>
      <div className="modal-footer">
        <button className="btn btn-secondary" onClick={onClose}>
          Close
        </button>
        <button className="btn btn-danger" onClick={onCancel}>
          Cancel Payment
        </button>
      </div>
    </div>
  </Modal>
);

class Billing extends Component {
  state = {
    openCommWindow: false,
    paymentLocation: "",
    paymentType: "",
    chequeNo: "",

    showEstimate: false,
    showConfirm: false,
    confirmedAmount: 0,
    showCancel: false,
    estimateValue: "",
    accountTaxSettings: [],
    isLoading: false,
    isLoading: false,
  };

  componentDidMount() {
    // Subscribe to Redux store for accountTaxSettings only
    this._unsubscribeStore = store.subscribe(() => {
      const storeState = store.getState();
      const taxSettingsState = storeState.taxSettings || {};
      
      const newSettings = taxSettingsState.accountTaxSettings || [];
      
      if (JSON.stringify(newSettings) !== JSON.stringify(this.state.accountTaxSettings)) {
        this.setState({ accountTaxSettings: newSettings });
      }
    });
    // Initialize from current store state
    const storeState = store.getState();
    const taxSettingsState = storeState.taxSettings || {};
    this.setState({
      accountTaxSettings: taxSettingsState.accountTaxSettings || [],
    });
  }

  componentWillUnmount() {
    if (this._unsubscribeStore) {
      this._unsubscribeStore();
    }
  }

  handleEstimate = () => {
    this.props.onEstimate(this.state.estimateValue);
    this.setState({ showEstimate: false });
  };

  handleConfirm = () => {
    this.props.onConfirmPayment();
    this.setState({ showConfirm: false });
  };

  handleCancel = (invoiceId) => {
    if (!invoiceId) return;

    this.props.onCancelPayment(invoiceId);

    this.setState({ showCancel: false });
  };
  handleValueChange = (e) => {
    const pickupToDropoffHours = Math.max(
      0,
      Number(this.state.pickupToDropoffTime || 0) / 60
    );
    const inputHours = Math.max(0, Number(e.target.value || 0));
    const totalHours = inputHours + pickupToDropoffHours;

    const hourlyCharge = calculateLaborCharge("", 0);

    this.setState({ estimatedHourlyTow: hourlyCharge });
  };
  createUI(charges, chargeOptionBilling, flag) {
    let chargeOption = [];
    chargeOption = chargeOptionBilling;
    let chargeArray = charges.split("|");
    chargeArray = chargeArray.filter((v) => v != "");

    return (chargeArray || []).map((el, i) => (
      <div className="row form-group" key={i}>
        <label
          className="col-md-12 form-control-label"
          htmlFor="advancedPayout"
        ></label>
        <div className="col-sm-3">
          <select
            className="form-control"
            disabled={flag}
            name="chargeName"
            value={el.split(",")[0]}
            onChange={(e) => {
              this.props.manipulateCustomCharge(i, 0, e.target.value);
            }}
          >
            {chargeOption.findIndex(
              (item) => item.optionText === el.split(",")[0]
            ) == -1
              ? chargeOption.push({
                  optionText: el.split(",")[0],
                  optionVal: 0,
                })
              : null}
            <option value="">SELECT</option>
            {chargeOption.map((item, i) => (
              <option key={i} value={item.optionText}>
                {item.optionText}
              </option>
            ))}
          </select>
        </div>
        <div className="col-sm-3">
          <div className="input-groups">
            <div className="input-groups-icon">
              <i className="fa fa-usd"></i>
            </div>
            <div className="input-groups-area">
              <input
                type="number"
                className="form-control"
                disabled={flag}
                name="chargeAmt"
                value={el.split(",")[1]}
                onChange={(e) => {
                  this.props.manipulateCustomCharge(i, 1, e.target.value);
                }}
              />
            </div>
          </div>
        </div>

        <div className="col-sm-2">
          <div className="checkbox">
            <label>
              <input
                type="checkbox"
                disabled={flag}
                checked={
                  this.props.invoiceInfo._invoiceObj.invoiceBilling.taxSettings
                    ?.customCharges?.[i]?.isTaxable || false
                }
                onChange={() => this.props.handleCustomChargeTaxToggle(i)}
              />{" "}
              Tax
            </label>
          </div>
        </div>

        <div className="col-sm-2">
          <input
            type="number"
            className="form-control"
            value={
              this.props.invoiceInfo._invoiceObj.invoiceBilling.taxSettings
                ?.customCharges?.[i]?.taxRate || 0
            }
            disabled={
              flag ||
              !(
                this.props.invoiceInfo._invoiceObj.invoiceBilling.taxSettings
                  ?.customCharges?.[i]?.isTaxable || false
              )
            }
            onChange={(e) =>
              this.props.handleCustomChargeTaxRate(i, e.target.value)
            }
            step="0.1"
            min="0"
            max="100"
          />
        </div>

        <span className="col-sm-2">
          <button
            title="Remove"
            name="charges"
            className="btn btn-sm btn-danger"
            disabled={flag}
            onClick={(e) => {
              e.preventDefault();
              this.props.deleteCustomCharge(i);
            }}
          >
            <i class="fa fa-close" aria-hidden="true"></i>
          </button>
        </span>
      </div>
    ));
  }

  calculateTax = () => {
    const { invoiceBilling } = this.props.invoiceInfo._invoiceObj;

    if (!invoiceBilling) return 0;

    if (
      !invoiceBilling.taxSettings ||
      !this.props.invoiceInfo._invoiceObj.accountId
    ) {
      return 0;
    }

    let totalTax = 0;

    if (invoiceBilling.taxSettings.towCharge?.isTaxable) {
      totalTax +=
        (parseFloat(invoiceBilling.towCharge || 0) *
          parseFloat(invoiceBilling.taxSettings.towCharge.taxRate || 0)) /
        100;
    }

    if (invoiceBilling.taxSettings.laborCharge?.isTaxable) {
      totalTax +=
        (parseFloat(invoiceBilling.laborCharge || 0) *
          parseFloat(invoiceBilling.taxSettings.laborCharge.taxRate || 0)) /
        100;
    }

    if (invoiceBilling.taxSettings.mileageCharge?.isTaxable) {
      totalTax +=
        (parseFloat(invoiceBilling.mileageCharge || 0) *
          parseFloat(invoiceBilling.taxSettings.mileageCharge.taxRate || 0)) /
        100;
    }

    // Calculate tax for storage charge
    if (invoiceBilling.taxSettings.storageCharge?.isTaxable) {
      totalTax +=
        (parseFloat(invoiceBilling.storageCharge || 0) *
          parseFloat(invoiceBilling.taxSettings.storageCharge.taxRate || 0)) /
        100;
    }

    // Calculate tax for gate charge
    if (invoiceBilling.taxSettings.gateCharge?.isTaxable) {
      totalTax +=
        (parseFloat(invoiceBilling.gateCharge || 0) *
          parseFloat(invoiceBilling.taxSettings.gateCharge.taxRate || 0)) /
        100;
    }

    // Calculate tax for advanced payout
    if (invoiceBilling.taxSettings.advancedPayout?.isTaxable) {
      totalTax +=
        (parseFloat(invoiceBilling.advancedPayout || 0) *
          parseFloat(invoiceBilling.taxSettings.advancedPayout.taxRate || 0)) /
        100;
    }

    // Calculate tax for misc charge
    if (invoiceBilling.taxSettings.miscCharge?.isTaxable) {
      totalTax +=
        (parseFloat(invoiceBilling.miscCharge || 0) *
          parseFloat(invoiceBilling.taxSettings.miscCharge.taxRate || 0)) /
        100;
    }

    // Calculate tax for custom charges
    if (
      invoiceBilling.userDefined_Charge &&
      invoiceBilling.userDefined_Charge !== ""
    ) {
      const customCharges = invoiceBilling.userDefined_Charge
        .split("|")
        .filter((v) => v != "");

      customCharges.forEach((charge, index) => {
        if (
          invoiceBilling.taxSettings.customCharges &&
          invoiceBilling.taxSettings.customCharges[index] &&
          invoiceBilling.taxSettings.customCharges[index].isTaxable
        ) {
          const chargeAmount = parseFloat(charge.split(",")[1] || 0);
          totalTax +=
            (chargeAmount *
              parseFloat(
                invoiceBilling.taxSettings.customCharges[index].taxRate || 0
              )) /
            100;
        }
      });
    }

    if (
      this.props.handleCharge &&
      Math.abs(totalTax - parseFloat(invoiceBilling.tax || 0)) > 0.01
    ) {
      this.props.handleCharge("tax", totalTax.toFixed(2));
    }

    return totalTax.toFixed(2);
  };

  componentDidUpdate(prevProps) {
    const { invoiceBilling: prevBilling } = prevProps.invoiceInfo._invoiceObj;
    const { invoiceBilling: currentBilling } =
      this.props.invoiceInfo._invoiceObj;

    const chargeFields = [
      "towCharge",
      "laborCharge",
      "mileageCharge",
      "storageCharge",
      "gateCharge",
      "advancedPayout",
      "miscCharge",
      "userDefined_Charge",
    ];

    const hasChargeChanged = chargeFields.some(
      (field) =>
        parseFloat(prevBilling[field] || 0) !==
        parseFloat(currentBilling[field] || 0)
    );

    // Also recalculate tax when taxSettings change (e.g., account tax settings
    // arrived after billing loaded, or user toggled a tax checkbox / changed a rate)
    const hasTaxSettingsChanged =
      prevBilling.taxSettings !== currentBilling.taxSettings;

    if (hasChargeChanged || hasTaxSettingsChanged) {
      this.calculateTax();
    }
  }
  render() {
    const { _invoiceObj, accountList, accountReqData, billingCommission } =
      this.props.invoiceInfo || {};
    const { invoiceBilling, invoicePayments } = _invoiceObj;
    const ratePlan = invoiceBilling.ratePlan || {};
    const invoiceLock =
      invoiceBilling.isVerifiedAndLocked == 1
        ? this.props.invoicePermission.edit
        : this.props.lockaccess.add;
    const isDisabled =
      !(this.props.invoicePermission.edit || false) ||
      invoiceBilling.isVerifiedAndLocked == 1;
    const childDisable =
      _invoiceObj.callStatus == "Cancel" || _invoiceObj.isDispatchCleared == 1;
    
    return (
      <Fragment>
        <div className="pd-10">
          <Form
            ref={(c) => {
              this.formBillngInfo = c;
              this.props.initCallBack(c);
            }}
          >
            <fieldset
              disabled={
                (_invoiceObj.callStatus || "").toUpperCase() == "CANCEL"
              }
            >
              <h6 className="text-blue text-bg-color form-group">Charges</h6>
              <div className="row">
                <div className="col">
                  <div class="card box-shadow">
                    <div class="card-body" style={{ padding: "0.5rem" }}>
                      <form>
                        <div className="row">
                          <div className="col">
                            <div className="">
                              <label
                                htmlFor="accountName"
                                className="form-label col-form-label"
                              >
                                ACCOUNT NAME
                              </label>
                              <div className="">
                                <Input
                                  type="text"
                                  disabled
                                  className="form-control form-control-sm"
                                  name="accountId"
                                  value={
                                    (
                                      accountList.find(
                                        (e) =>
                                          e.optionVal ==
                                          (
                                            _invoiceObj.accountId || ""
                                          ).toString()
                                      ) || {}
                                    ).optionText
                                  }
                                />
                              </div>
                              <label
                                htmlFor="accountName"
                                className="form-label col-form-label"
                              >
                                PAYMENT ACCEPTED:{" "}
                                {accountReqData.paymentType || "NONE"}
                              </label>
                            </div>
                          </div>

                          <div className="col">
                            <div className="">
                              <label
                                htmlFor="accountName"
                                className="form-label col-form-label"
                              >
                                BILLING TO
                              </label>
                              <div className="">
                                <ReactSelect
                                  name="billingTo"
                                  closeMenuOnSelect={true}
                                  notAmultiSelect={true}
                                  isDisabled={isDisabled || childDisable}
                                  options={accountList
                                    .filter(
                                      (item) => item.idCompany == getCompanyId()
                                    )
                                    .map((item, t) => {
                                      return {
                                        value: item.optionVal,
                                        label: item.optionText,
                                      };
                                    })}
                                  value={{
                                    value: (
                                      invoiceBilling.billingTo || ""
                                    ).toString(),
                                    label: (
                                      accountList.find(
                                        (e) =>
                                          parseInt(e.optionVal) ==
                                            invoiceBilling.billingTo || ""
                                      ) || {}
                                    ).optionText,
                                  }}
                                  onChange={(selectedOption) => {
                                    this.props.serviceCallInfoFieldChange(
                                      "invoiceBilling",
                                      "billingTo",
                                      parseInt(selectedOption.value)
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col">
                            <div className="">
                              <label
                                htmlFor="accountName"
                                className="form-label col-form-label"
                              >
                                ACCOUNT RATE PLAN
                              </label>
                              <div className="">
                                <ReactSelect
                                  name="accountRatePlanId"
                                  closeMenuOnSelect={true}
                                  isDisabled={isDisabled || childDisable}
                                  notAmultiSelect={true}
                                  options={(
                                    accountReqData.ratePlanOptions || []
                                  ).map((item, t) => {
                                    return {
                                      value: item.optionVal,
                                      label: item.optionText,
                                    };
                                  })}
                                  value={{
                                    value: _invoiceObj.accountRatePlanId,
                                    label:
                                      (
                                        (
                                          accountReqData.ratePlanOptions || []
                                        ).find(
                                          (e) =>
                                            e.optionVal ==
                                            _invoiceObj.accountRatePlanId
                                        ) || ""
                                      ).optionText || "",
                                  }}
                                  onChange={(selectedOption) => {
                                    this.props.serviceCallInfoFieldChange(
                                      "",
                                      "accountRatePlanId",
                                      parseInt(selectedOption.value)
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              {_invoiceObj.serviceCallInfo.serviceCallType === "itemized_billing" ? (
                <LineItems
                  lineItems={_invoiceObj.lineItems || []}
                  chargeOptions={(() => {
                    const options = [];

                    // Read account tax settings from component state (synced from Redux store)
                    const accountTaxSettings = this.state.accountTaxSettings || [];

                    accountTaxSettings.forEach((charge) => {
                      if (charge.chargeName) {
                        options.push({
                          chargeName: charge.chargeName,
                          chargeListId:
                            charge.chargeListId || charge.idChargeList,
                          isTaxable: charge.isTaxable || false,
                          taxRate: charge.taxRate || 0,
                          global: charge.global || false,
                        });
                      }
                    });

                    // Fallback: if no account tax settings yet, try from invoice billing taxSettings
                    if (options.length === 0 && invoiceBilling.taxSettings) {

                      const standardCharges = [
                        { key: "towCharge", name: "Tow Charge" },
                        { key: "laborCharge", name: "Labor Charge" },
                        { key: "mileageCharge", name: "Mileage Charge" },
                        { key: "storageCharge", name: "Storage Charge" },
                        { key: "gateCharge", name: "Gate Charge" },
                        { key: "advancedPayout", name: "Advanced Payout" },
                        { key: "miscCharge", name: "Misc Charge" },
                      ];

                      standardCharges.forEach((charge) => {
                        const setting = invoiceBilling.taxSettings[charge.key];
                        if (setting && setting.chargeListId) {
                          options.push({
                            chargeName: charge.name,
                            chargeListId: setting.chargeListId,
                            isTaxable: setting.isTaxable || false,
                            taxRate: setting.taxRate || 0,
                            global: true,
                          });
                        }
                      });

                      if (
                        invoiceBilling.taxSettings.customCharges &&
                        invoiceBilling.taxSettings.customCharges.length > 0
                      ) {
                        invoiceBilling.taxSettings.customCharges.forEach(
                          (customCharge) => {
                            if (customCharge.chargeListId) {
                              options.push({
                                chargeName: customCharge.chargeName,
                                chargeListId: customCharge.chargeListId,
                                isTaxable: customCharge.isTaxable || false,
                                taxRate: customCharge.taxRate || 0,
                                global: false,
                              });
                            }
                          }
                        );
                      }
                    }

                    return options;
                  })()}
                  paymentAmt={float(_invoiceObj.invoiceBilling.paymentAmt)}
                  isDisabled={isDisabled || childDisable}
                  onUpdateLineItems={(lineItems) => {
                    this.props.serviceCallInfoFieldChange(
                      "",
                      "lineItems",
                      lineItems
                    );

                    // Calculate pre-tax subtotal
                    const subtotal = lineItems.reduce(
                      (sum, item) => sum + (parseFloat(item.total) || 0),
                      0
                    );

                    // Calculate tax from all taxable line items
                    let tax = 0;
                    lineItems.forEach((item) => {
                      if (item.taxApplicable && item.taxRate) {
                        tax +=
                          ((parseFloat(item.total) || 0) *
                            (parseFloat(item.taxRate) || 0)) /
                          100;
                      }
                    });

                    const totalCharge = subtotal + tax;
                    const paymentAmt = parseFloat(invoiceBilling.paymentAmt) || 0;
                    const discount = parseFloat(invoiceBilling.totalDiscount) || 0;
                    const balanceAmt = totalCharge - paymentAmt - discount;

                    // Use serviceCallInfoFieldChange for direct field setting.
                    // Do NOT use handleCharge for totalCharge/balanceAmt — handleCharge
                    // adds the diff to totalCharge internally, which double-counts when
                    // the field being set IS totalCharge.
                    this.props.serviceCallInfoFieldChange("invoiceBilling", "tax", parseFloat(tax.toFixed(2)));
                    this.props.serviceCallInfoFieldChange("invoiceBilling", "totalCharge", parseFloat(totalCharge.toFixed(2)));
                    this.props.serviceCallInfoFieldChange("invoiceBilling", "balanceAmt", parseFloat(balanceAmt.toFixed(2)));
                  }}
                  onTaxChange={(tax) => {
                    // Called from LineItems componentDidUpdate when tax changes
                    // Recalculate totals with updated tax
                    const lineItems = _invoiceObj.lineItems || [];
                    const subtotal = lineItems.reduce(
                      (sum, item) => sum + (parseFloat(item.total) || 0),
                      0
                    );
                    const totalCharge = subtotal + tax;
                    const paymentAmt = parseFloat(invoiceBilling.paymentAmt) || 0;
                    const discount = parseFloat(invoiceBilling.totalDiscount) || 0;
                    const balanceAmt = totalCharge - paymentAmt - discount;

                    this.props.serviceCallInfoFieldChange("invoiceBilling", "tax", parseFloat(tax.toFixed(2)));
                    this.props.serviceCallInfoFieldChange("invoiceBilling", "totalCharge", parseFloat(totalCharge.toFixed(2)));
                    this.props.serviceCallInfoFieldChange("invoiceBilling", "balanceAmt", parseFloat(balanceAmt.toFixed(2)));
                  }}
                  onTaxToggle={this.props.handleCustomChargeTaxToggle}
                  onTaxRateChange={this.props.handleCustomChargeTaxRate}
                />
              ) : (
                <div className="row mb-10">
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col">
                        <div className="">
                          <label
                            htmlFor="accountName"
                            className="form-label col-form-label"
                          >
                            HOURLY RATE
                          </label>
                          <div className="input-groups">
                            <div class="input-groups-icon Billing-HourlyTow">
                              $
                            </div>
                            <div class="input-groups-area">
                              <Input
                                type="text"
                                disabled
                                className="form-control form-control-sm Billing-HourlyTow"
                                name="service_hourly_rate"
                                value={float(ratePlan.service_hourly_rate)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <div className="">
                          <label
                            htmlFor="accountName"
                            className="form-label col-form-label"
                          >
                            BILLABLE HOURS
                          </label>
                          <div className="">
                            <Input
                              type="text"
                              disabled
                              className="form-control form-control-sm Billing-HourlyTow"
                              value={invoiceBilling.serviceBillableHours}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <div className="">
                          <label
                            htmlFor="accountName"
                            className="form-label col-form-label"
                          >
                            UNLOADED MILES
                          </label>
                          <div className="">
                            <Input
                              type="number"
                              className="form-control form-control-sm Billing-MileageCharge"
                              name="unloadedMiles"
                              value={invoiceBilling.unloadedMiles}
                              steps="0.1"
                              disabled={isDisabled || childDisable}
                              onChange={(e) => {
                                this.props.mileageManualCal(
                                  e.target.name,
                                  e.target.value
                                );
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <div className="">
                          <label
                            htmlFor="accountName"
                            className="form-label col-form-label"
                          >
                            RATE
                          </label>
                          <div className="input-groups">
                            <div class="input-groups-icon Billing-MileageCharge">
                              $
                            </div>
                            <div class="input-groups-area">
                              <Input
                                type="number"
                                className="form-control form-control-sm Billing-MileageCharge"
                                name="unloadedMilesRate"
                                value={invoiceBilling.unloadedMilesRate}
                                steps="0.1"
                                disabled={isDisabled || childDisable}
                                onChange={(e) => {
                                  this.props.mileageManualCal(
                                    e.target.name,
                                    e.target.value
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <div className="">
                          <label
                            htmlFor="accountName"
                            className="form-label col-form-label"
                          >
                            LOADED MILES
                          </label>
                          <div className="">
                            <Input
                              type="number"
                              className="form-control form-control-sm Billing-MileageCharge"
                              name="loadedMiles"
                              value={invoiceBilling.loadedMiles}
                              steps="0.1"
                              disabled={isDisabled || childDisable}
                              onChange={(e) => {
                                this.props.mileageManualCal(
                                  e.target.name,
                                  e.target.value
                                );
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <div className="">
                          <label
                            htmlFor="accountName"
                            className="form-label col-form-label"
                          >
                            RATE
                          </label>
                          <div className="input-groups">
                            <div class="input-groups-icon Billing-MileageCharge">
                              $
                            </div>
                            <div class="input-groups-area">
                              <Input
                                type="text"
                                className="form-control form-control-sm Billing-MileageCharge"
                                name="loadedMilesRate"
                                value={invoiceBilling.loadedMilesRate}
                                disabled={isDisabled || childDisable}
                                onChange={(e) => {
                                  this.props.mileageManualCal(
                                    e.target.name,
                                    e.target.value
                                  );
                                }}
                                steps="0.1"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <div className="">
                          <label
                            htmlFor="accountName"
                            className="form-label col-form-label"
                          >
                            CALENDAR DAYS
                          </label>
                          <div className="">
                            <Input
                              type="text"
                              className="form-control form-control-sm"
                              disabled
                              value={float(invoiceBilling.calendarDays)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <div className="">
                          <label
                            htmlFor="accountName"
                            className="form-label col-form-label"
                          >
                            BILLABLE DAYS
                          </label>
                          <div className="">
                            <Input
                              type="text"
                              className="form-control form-control-sm Billing-StorageCharge"
                              disabled
                              placeholder={float(invoiceBilling.paidNoOfDays)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <div className="">
                          <label
                            htmlFor="accountName"
                            className="form-label col-form-label"
                          >
                            DAILY STORAGE RATE
                          </label>
                          <div className="input-groups">
                            <div class="input-groups-icon Billing-StorageCharge">
                              $
                            </div>
                            <div class="input-groups-area">
                              <Input
                                type="text"
                                className="form-control form-control-sm Billing-StorageCharge"
                                disabled
                                value={float(
                                  invoiceBilling.storageAfterLimitCharge
                                )}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <div className="">
                          <label
                            htmlFor="accountName"
                            className="form-label col-form-label"
                          >
                            PO#
                          </label>
                          <div className="">
                            <Input
                              type="text"
                              className="form-control form-control-sm"
                              name="pONo"
                              value={invoiceBilling.pONo}
                              disabled={isDisabled || childDisable}
                              onChange={(e) => {
                                this.props.serviceCallInfoFieldChange(
                                  "invoiceBilling",
                                  e.target.name,
                                  e.target.value
                                );
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <div className="">
                          <label
                            htmlFor="accountName"
                            className="form-label col-form-label"
                          >
                            SERVICE ADVISOR NAME
                          </label>
                          <div className="">
                            <Input
                              type="text"
                              className="form-control form-control-sm"
                              name="serviceAdvisorName"
                              value={invoiceBilling.serviceAdvisorName || ""}
                              disabled={isDisabled || childDisable}
                              onChange={(e) => {
                                this.props.serviceCallInfoFieldChange(
                                  "invoiceBilling",
                                  e.target.name,
                                  e.target.value
                                );
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-10">
                      <div className="col">
                        <div className="">
                          <label
                            htmlFor="accountName"
                            className="form-label col-form-label"
                          >
                            REPAIR ORDER #
                          </label>
                          <div className="">
                            <Input
                              type="text"
                              className="form-control form-control-sm"
                              name="repairOrderNo"
                              value={invoiceBilling.repairOrderNo || ""}
                              disabled={isDisabled || childDisable}
                              onChange={(e) => {
                                this.props.serviceCallInfoFieldChange(
                                  "invoiceBilling",
                                  e.target.name,
                                  e.target.value
                                );
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-10">
                      <div className="col-sm-4">
                        <div className="custom-control custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            disabled={isDisabled}
                            name="isPoliceHold"
                            id="isPoliceHold"
                            checked={(invoiceBilling.isPoliceHold || 0) == 1}
                            onChange={(e) => {
                              this.props.serviceCallInfoFieldChange(
                                "invoiceBilling",
                                e.target.name,
                                (invoiceBilling.isPoliceHold || 0) == 1 ? 0 : 1
                              );
                            }}
                          />
                          <label
                            htmlFor="isPoliceHold"
                            className="custom-control-label"
                          >
                            POLICE HOLD
                          </label>
                        </div>
                      </div>
                      <div className="col-sm-3">
                        <div className="custom-control custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            name="isVerifiedAndLocked"
                            id="isVerifiedAndLocked"
                            disabled={!invoiceLock}
                            checked={
                              (invoiceBilling.isVerifiedAndLocked || 0) == 1
                            }
                            onChange={(e) => {
                              this.props.serviceCallInfoFieldChange(
                                "invoiceBilling",
                                e.target.name,
                                (invoiceBilling.isVerifiedAndLocked || 0) == 1
                                  ? 0
                                  : 1
                              );
                            }}
                          />
                          <label
                            htmlFor="isVerifiedAndLocked"
                            className="custom-control-label"
                          >
                            LOCKED
                          </label>
                        </div>
                      </div>
                      <div className="col-sm-3">
                        <div className="custom-control custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            disabled={isDisabled}
                            name="verifiedForReview"
                            id="verifiedForReview"
                            checked={
                              (invoiceBilling.verifiedForReview || 0) == 1
                            }
                            onChange={(e) => {
                              this.props.serviceCallInfoFieldChange(
                                "invoiceBilling",
                                e.target.name,
                                (invoiceBilling.verifiedForReview || 0) == 1
                                  ? 0
                                  : 1
                              );
                            }}
                          />
                          <label
                            htmlFor="verifiedForReview"
                            className="custom-control-label"
                          >
                            VERIFIED
                          </label>
                        </div>
                      </div>
                      <div className="col-sm-2 text-right">
                        <button
                          type="button"
                          disabled={isDisabled}
                          className="btn btn-info btn-sm pull-right"
                          onClick={this.props.setReview}
                        >
                          <i className="fa fa-flag-o" aria-hidden="true"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="row">
                          <div className="col">
                            <div className="">
                              <label
                                htmlFor="accountName"
                                className="form-label col-form-label"
                              >
                                FLAT TOW
                              </label>
                              <div className="input-groups">
                                <div class="input-groups-icon">$</div>
                                <div class="input-groups-area">
                                  <Input
                                    type="number"
                                    className="form-control form-control-sm"
                                    name="towCharge"
                                    value={invoiceBilling.towCharge}
                                    steps="0.1"
                                    disabled={isDisabled || childDisable}
                                    onChange={(e) => {
                                      this.props.handleCharge(
                                        e.target.name,
                                        e.target.value
                                      );
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Add tax checkbox and rate field */}
                      <div className="col-md-3">
                        <div className="row">
                          <div className="col">
                            <div className="">
                              <label
                                htmlFor="taxTowCharge"
                                className="form-label col-form-label"
                              >
                                Tax
                              </label>
                              <div className="text-center">
                                <input
                                  type="checkbox"
                                  id="taxTowCharge"
                                  checked={
                                    invoiceBilling.taxSettings?.towCharge
                                      ?.isTaxable || false
                                  }
                                  disabled={isDisabled || childDisable}
                                  onChange={() =>
                                    this.props.handleTaxToggle("towCharge")
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="row">
                          <div className="col">
                            <div className="">
                              <label
                                htmlFor="rateTowCharge"
                                className="form-label col-form-label"
                              >
                                Rate
                              </label>
                              <div className="">
                                <Input
                                  type="number"
                                  className="form-control form-control-sm"
                                  id="rateTowCharge"
                                  value={
                                    invoiceBilling.taxSettings?.towCharge
                                      ?.taxRate || 0
                                  }
                                  disabled={
                                    isDisabled ||
                                    childDisable ||
                                    !(
                                      invoiceBilling.taxSettings?.towCharge
                                        ?.isTaxable || false
                                    )
                                  }
                                  onChange={(e) =>
                                    this.props.handleTaxRate(
                                      "towCharge",
                                      e.target.value
                                    )
                                  }
                                  step="0.1"
                                  min="0"
                                  max="100"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="">
                          <label
                            htmlFor="accountName"
                            className="form-label col-form-label"
                          >
                            HOURLY TOW
                          </label>
                          <div className="input-groups">
                            <div class="input-groups-icon Billing-HourlyTow">
                              $
                            </div>
                            <div class="input-groups-area">
                              <Input
                                type="text"
                                className="form-control form-control-sm Billing-HourlyTow"
                                disabled
                                name="laborCharge"
                                value={float(invoiceBilling.laborCharge)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="row">
                          <div className="col">
                            <div className="">
                              <label
                                htmlFor="taxLaborCharge"
                                className="form-label col-form-label"
                              >
                                Tax
                              </label>
                              <div className="text-center">
                                <input
                                  type="checkbox"
                                  id="taxLaborCharge"
                                  checked={
                                    invoiceBilling.taxSettings?.laborCharge
                                      ?.isTaxable || false
                                  }
                                  disabled={isDisabled || childDisable}
                                  onChange={() =>
                                    this.props.handleTaxToggle("laborCharge")
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="row">
                          <div className="col">
                            <div className="">
                              <label
                                htmlFor="rateLaborCharge"
                                className="form-label col-form-label"
                              >
                                Rate
                              </label>
                              <div className="">
                                <Input
                                  type="number"
                                  className="form-control form-control-sm"
                                  id="rateLaborCharge"
                                  value={
                                    invoiceBilling.taxSettings?.laborCharge
                                      ?.taxRate || 0
                                  }
                                  disabled={
                                    isDisabled ||
                                    childDisable ||
                                    !(
                                      invoiceBilling.taxSettings?.laborCharge
                                        ?.isTaxable || false
                                    )
                                  }
                                  onChange={(e) =>
                                    this.props.handleTaxRate(
                                      "laborCharge",
                                      e.target.value
                                    )
                                  }
                                  step="0.1"
                                  min="0"
                                  max="100"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="">
                          <label
                            htmlFor="accountName"
                            className="form-label col-form-label"
                          >
                            MILEAGE CHARGE
                          </label>
                          <div className="input-groups">
                            <div class="input-groups-icon Billing-MileageCharge">
                              $
                            </div>
                            <div class="input-groups-area">
                              <Input
                                type="text"
                                className="form-control form-control-sm Billing-MileageCharge"
                                disabled
                                name="accountName"
                                value={float(invoiceBilling.mileageCharge)}
                                requiredmsg="Please enter Account Name"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="row">
                          <div className="col">
                            <div className="">
                              <label
                                htmlFor="taxMileageCharge"
                                className="form-label col-form-label"
                              >
                                Tax
                              </label>
                              <div className="text-center">
                                <input
                                  type="checkbox"
                                  id="taxMileageCharge"
                                  checked={
                                    invoiceBilling.taxSettings?.mileageCharge
                                      ?.isTaxable || false
                                  }
                                  disabled={isDisabled || childDisable}
                                  onChange={() =>
                                    this.props.handleTaxToggle("mileageCharge")
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="row">
                          <div className="col">
                            <div className="">
                              <label
                                htmlFor="rateMileageCharge"
                                className="form-label col-form-label"
                              >
                                Rate
                              </label>
                              <div className="">
                                <Input
                                  type="number"
                                  className="form-control form-control-sm"
                                  id="rateMileageCharge"
                                  value={
                                    invoiceBilling.taxSettings?.mileageCharge
                                      ?.taxRate || 0
                                  }
                                  disabled={
                                    isDisabled ||
                                    childDisable ||
                                    !(
                                      invoiceBilling.taxSettings?.mileageCharge
                                        ?.isTaxable || false
                                    )
                                  }
                                  onChange={(e) =>
                                    this.props.handleTaxRate(
                                      "mileageCharge",
                                      e.target.value
                                    )
                                  }
                                  step="0.1"
                                  min="0"
                                  max="100"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="">
                          <label
                            htmlFor="accountName"
                            className="form-label col-form-label"
                          >
                            STORAGE CHARGE
                          </label>
                          <div className="input-groups">
                            <div class="input-groups-icon Billing-StorageCharge">
                              $
                            </div>
                            <div class="input-groups-area">
                              <Input
                                type="text"
                                className="form-control form-control-sm Billing-StorageCharge"
                                disabled
                                name="accountName"
                                value={float(invoiceBilling.storageCharge)}
                                requiredmsg="Please enter Account Name"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="row">
                          <div className="col">
                            <div className="">
                              <label
                                htmlFor="taxStorageCharge"
                                className="form-label col-form-label"
                              >
                                Tax
                              </label>
                              <div className="text-center">
                                <input
                                  type="checkbox"
                                  id="taxStorageCharge"
                                  checked={
                                    invoiceBilling.taxSettings?.storageCharge
                                      ?.isTaxable || false
                                  }
                                  disabled={isDisabled || childDisable}
                                  onChange={() =>
                                    this.props.handleTaxToggle("storageCharge")
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="row">
                          <div className="col">
                            <div className="">
                              <label
                                htmlFor="rateStorageCharge"
                                className="form-label col-form-label"
                              >
                                Rate
                              </label>
                              <div className="">
                                <Input
                                  type="number"
                                  className="form-control form-control-sm"
                                  id="rateStorageCharge"
                                  value={
                                    invoiceBilling.taxSettings?.storageCharge
                                      ?.taxRate || 0
                                  }
                                  disabled={
                                    isDisabled ||
                                    childDisable ||
                                    !(
                                      invoiceBilling.taxSettings?.storageCharge
                                        ?.isTaxable || false
                                    )
                                  }
                                  onChange={(e) =>
                                    this.props.handleTaxRate(
                                      "storageCharge",
                                      e.target.value
                                    )
                                  }
                                  step="0.1"
                                  min="0"
                                  max="100"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="">
                          <label
                            htmlFor="accountName"
                            className="form-label col-form-label"
                          >
                            GATE CHARGE
                          </label>
                          <div className="input-groups">
                            <div class="input-groups-icon">$</div>
                            <div class="input-groups-area">
                              <Input
                                type="number"
                                className="form-control form-control-sm"
                                name="gateCharge"
                                value={invoiceBilling.gateCharge}
                                steps="0.1"
                                disabled={isDisabled || childDisable}
                                onChange={(e) => {
                                  this.props.handleCharge(
                                    e.target.name,
                                    e.target.value
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="row">
                          <div className="col">
                            <div className="">
                              <label
                                htmlFor="taxGateCharge"
                                className="form-label col-form-label"
                              >
                                Tax
                              </label>
                              <div className="text-center">
                                <input
                                  type="checkbox"
                                  id="taxGateCharge"
                                  checked={
                                    invoiceBilling.taxSettings?.gateCharge
                                      ?.isTaxable || false
                                  }
                                  disabled={isDisabled || childDisable}
                                  onChange={() =>
                                    this.props.handleTaxToggle("gateCharge")
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="row">
                          <div className="col">
                            <div className="">
                              <label
                                htmlFor="rateGateCharge"
                                className="form-label col-form-label"
                              >
                                Rate
                              </label>
                              <div className="">
                                <Input
                                  type="number"
                                  className="form-control form-control-sm"
                                  id="rateGateCharge"
                                  value={
                                    invoiceBilling.taxSettings?.gateCharge
                                      ?.taxRate || 0
                                  }
                                  disabled={
                                    isDisabled ||
                                    childDisable ||
                                    !(
                                      invoiceBilling.taxSettings?.gateCharge
                                        ?.isTaxable || false
                                    )
                                  }
                                  onChange={(e) =>
                                    this.props.handleTaxRate(
                                      "gateCharge",
                                      e.target.value
                                    )
                                  }
                                  step="0.1"
                                  min="0"
                                  max="100"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mb-10">
                      <div className="col-md-6">
                        <div className="">
                          <label
                            htmlFor="accountName"
                            className="form-label col-form-label"
                          >
                            ADVANCED PAYOUT
                          </label>
                          <div className="input-groups">
                            <div class="input-groups-icon">$</div>
                            <div class="input-groups-area">
                              <Input
                                type="number"
                                className="form-control form-control-sm"
                                name="advancedPayout"
                                value={invoiceBilling.advancedPayout}
                                steps="0.1"
                                disabled={isDisabled || childDisable}
                                onChange={(e) => {
                                  this.props.handleCharge(
                                    e.target.name,
                                    e.target.value
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="row">
                          <div className="col">
                            <div className="">
                              <label
                                htmlFor="taxAdvancedPayout"
                                className="form-label col-form-label"
                              >
                                Tax
                              </label>
                              <div className="text-center">
                                <input
                                  type="checkbox"
                                  id="taxAdvancedPayout"
                                  checked={
                                    invoiceBilling.taxSettings?.advancedPayout
                                      ?.isTaxable || false
                                  }
                                  disabled={isDisabled || childDisable}
                                  onChange={() =>
                                    this.props.handleTaxToggle("advancedPayout")
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="row">
                          <div className="col">
                            <div className="">
                              <label
                                htmlFor="rateAdvancedPayout"
                                className="form-label col-form-label"
                              >
                                Rate
                              </label>
                              <div className="">
                                <Input
                                  type="number"
                                  className="form-control form-control-sm"
                                  id="rateAdvancedPayout"
                                  value={
                                    invoiceBilling.taxSettings?.advancedPayout
                                      ?.taxRate || 0
                                  }
                                  disabled={
                                    isDisabled ||
                                    childDisable ||
                                    !(
                                      invoiceBilling.taxSettings?.advancedPayout
                                        ?.isTaxable || false
                                    )
                                  }
                                  onChange={(e) =>
                                    this.props.handleTaxRate(
                                      "advancedPayout",
                                      e.target.value
                                    )
                                  }
                                  step="0.1"
                                  min="0"
                                  max="100"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col">
                        <Input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="MISC. CHARGE NAME"
                          name="miscChargeLabel"
                          value={invoiceBilling.miscChargeLabel || ""}
                          disabled={isDisabled || childDisable}
                          onChange={(e) => {
                            this.props.serviceCallInfoFieldChange(
                              "invoiceBilling",
                              e.target.name,
                              e.target.value
                            );
                          }}
                        />
                      </div>
                    </div>
                    <div className="row mb-10">
                      <div className="col-md-6">
                        <div className="">
                          <label
                            htmlFor="accountName"
                            className="form-label col-form-label"
                          >
                            MISC. CHARGE
                          </label>
                          <div className="input-groups">
                            <div class="input-groups-icon">$</div>
                            <div class="input-groups-area">
                              <Input
                                type="number"
                                className="form-control form-control-sm"
                                name="miscCharge"
                                value={invoiceBilling.miscCharge}
                                steps="0.1"
                                disabled={isDisabled || childDisable}
                                onChange={(e) => {
                                  this.props.handleCharge(
                                    e.target.name,
                                    e.target.value
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="row">
                          <div className="col">
                            <div className="">
                              <label
                                htmlFor="taxMiscCharge"
                                className="form-label col-form-label"
                              >
                                Tax
                              </label>
                              <div className="text-center">
                                <input
                                  type="checkbox"
                                  id="taxMiscCharge"
                                  checked={
                                    invoiceBilling.taxSettings?.miscCharge
                                      ?.isTaxable || false
                                  }
                                  disabled={isDisabled || childDisable}
                                  onChange={() =>
                                    this.props.handleTaxToggle("miscCharge")
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="row">
                          <div className="col">
                            <div className="">
                              <label
                                htmlFor="rateMiscCharge"
                                className="form-label col-form-label"
                              >
                                Rate
                              </label>
                              <div className="">
                                <Input
                                  type="number"
                                  className="form-control form-control-sm"
                                  id="rateMiscCharge"
                                  value={
                                    invoiceBilling.taxSettings?.miscCharge
                                      ?.taxRate || 0
                                  }
                                  disabled={
                                    isDisabled ||
                                    childDisable ||
                                    !(
                                      invoiceBilling.taxSettings?.miscCharge
                                        ?.isTaxable || false
                                    )
                                  }
                                  onChange={(e) =>
                                    this.props.handleTaxRate(
                                      "miscCharge",
                                      e.target.value
                                    )
                                  }
                                  step="0.1"
                                  min="0"
                                  max="100"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col">
                        <input
                          type="button"
                          className="btn btn-sm btn-success"
                          name="addCustomCharge"
                          value={"Add Custom Charge"}
                          onClick={this.props.addCutomCharge}
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                    <div className="row mb-10">
                      <div className="col">
                        <div className="">
                          <div className="">
                            {invoiceBilling.userDefined_Charge != ""
                              ? this.createUI(
                                  invoiceBilling.userDefined_Charge,
                                  invoiceBilling.customChargesOptions || [],
                                  isDisabled || childDisable
                                )
                              : null}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <div class="card box-shadow">
                          <div class="card-body" style={{ padding: "0.5rem" }}>
                            <form>
                              <div className="row">
                                <div className="col">
                                  <div className="">
                                    <label
                                      htmlFor="accountName"
                                      className="form-label col-form-label"
                                    >
                                      TAX
                                    </label>
                                    <div className="input-groups">
                                      <div class="input-groups-icon">$</div>
                                      <div class="input-groups-area">
                                        <Input
                                          type="number"
                                          className="form-control form-control-sm"
                                          name="tax"
                                          value={invoiceBilling.tax}
                                          disabled={true}
                                          readOnly={true}
                                        />
                                      </div>
                                    </div>
                                    <small className="text-muted">
                                      Auto-calculated based on tax settings
                                    </small>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col">
                                  <div className="">
                                    <label
                                      htmlFor="accountName"
                                      className="form-label col-form-label"
                                    >
                                      SUB TOTAL
                                    </label>
                                    <div className="input-groups">
                                      <div class="input-groups-icon">$</div>
                                      <div class="input-groups-area">
                                        <Input
                                          type="text"
                                          className="form-control form-control-sm"
                                          disabled
                                          name="accountName"
                                          value={float(
                                            invoiceBilling.totalCharge
                                          )}
                                          requiredmsg="Please enter Account Name"
                                          onChange={(e) => {
                                            this.props.serviceCallInfoFieldChange(
                                              "invoiceBilling",
                                              e.target.name,
                                              e.target.value
                                            );
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col">
                                  <div className="">
                                    <label
                                      htmlFor="accountName"
                                      className="form-label col-form-label"
                                    >
                                      DISCOUNT
                                    </label>
                                    <div className="input-groups">
                                      <div class="input-groups-icon">$</div>
                                      <div class="input-groups-area">
                                        <Input
                                          type="text"
                                          className="form-control form-control-sm"
                                          disabled={isDisabled || childDisable}
                                          onChange={(e) => {
                                            this.props.handleCharge(
                                              e.target.name,
                                              e.target.value
                                            );
                                          }}
                                          name="flatDiscount"
                                          value={float(
                                            invoiceBilling.flatDiscount
                                          )}
                                          requiredmsg="Please enter Account Name"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col">
                                  <div className="">
                                    <label
                                      htmlFor="accountName"
                                      className="form-label col-form-label"
                                    >
                                      PAYMENTS
                                    </label>
                                    <div className="input-groups">
                                      <div class="input-groups-icon">$</div>
                                      <div class="input-groups-area">
                                        <Input
                                          type="text"
                                          className="form-control form-control-sm"
                                          disabled
                                          name="accountName"
                                          value={float(
                                            invoiceBilling.paymentAmt
                                          )}
                                          requiredmsg="Please enter Account Name"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col">
                                  <div className="">
                                    <label
                                      htmlFor="accountName"
                                      className="form-label col-form-label"
                                    >
                                      BALANCE DUE
                                    </label>
                                    <div className="input-groups">
                                      <div class="input-groups-icon">$</div>
                                      <div class="input-groups-area">
                                        <Input
                                          type="text"
                                          className="form-control form-control-sm"
                                          disabled
                                          name="balanceAmt"
                                          value={float(
                                            invoiceBilling.balanceAmt
                                          )}
                                          requiredmsg="Please enter Account Name"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col">
                                    {!!invoiceBilling.enbaleRecalculate && (
                                      <div className="col-12 text-center mt-4">
                                        <div className="input-group justify-content-center">
                                          <button
                                            onClick={() =>
                                              this.setState({
                                                showEstimate: true,
                                              })
                                            }
                                            className="btn btn-success"
                                            type="button"
                                            title="confirm"
                                          >
                                            {"Estimate"}{" "}
                                            <i className="fa fa-check"></i>
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                    {!invoiceBilling.enbaleRecalculate &&
                                      !!invoiceBilling.isPaymentConfirmed && (
                                        <div className="col-12 text-center mt-4">
                                          <div className="input-group justify-content-center">
                                            <button
                                              onClick={() =>
                                                this.setState({
                                                  showConfirm: true,
                                                })
                                              }
                                              className="btn btn-warning"
                                              type="button"
                                              title="confirm"
                                            >
                                              {"Confirm Payment"}{" "}
                                              <i className="fa fa-check"></i>
                                            </button>
                                          </div>
                                        </div>
                                      )}
                                    {!!invoiceBilling.confirmedByDispatcher && (
                                      <div className="col-12 text-center mt-4">
                                        <div className="input-group justify-content-center">
                                          <button
                                            onClick={() =>
                                              this.setState({
                                                showCancel: true,
                                              })
                                            }
                                            className="btn btn-danger"
                                            type="button"
                                            title="confirm"
                                          >
                                            {"cancel Payment"}{" "}
                                            <i className="fa fa-check"></i>
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </fieldset>
            <Payment
              paymentAccess={this.props.paymentAccess}
              invoicePayments={invoicePayments || []}
              invoiceId={this.props.invoiceInfo._invoiceObj.invoiceId}
              locationList={this.props.reviewLocation || []}
              isDisabled={isDisabled}
              addUpdatePayments={(invoiceId, obj) =>
                this.props.addUpdatePayments(invoiceId, obj)
              }
              deletePayments={(id, invoice) => {
                this.props.deletePayments(id, invoice);
              }}
            />
          </Form>
          <Modal show={this.state.openCommWindow}>
            <div className="modal-body">
              <h2>Commission</h2>
              <div className="row">
                <div className="col-6">
                  <label htmlFor="driverId">Driver ID:</label>
                </div>
                <div className="col-6">
                  <input
                    className="form-control"
                    type="text"
                    value={_invoiceObj.driverId}
                    disabled
                  />
                </div>
              </div>
              <div className="row">
                <div
                  className="col-1"
                  style={{ display: "relative", float: "right" }}
                >
                  <input
                    type="checkbox"
                    id="loadDefaultCommission"
                    disabled={isDisabled || !this.props.commissionaccess.edit}
                    onChange={(e) => {
                      this.props.getInvoiceComm(e.target.checked || false);
                    }}
                  />
                </div>
                <div className="col-11">
                  <label htmlFor="loadDefaultCommission">
                    {"Load Default Commission"}
                  </label>
                </div>
              </div>
              <br />
              <h5>Commission Rates</h5>
              <div className="row">
                <div className="col-6">
                  <label htmlFor="flatRate">{"Flat Rate "}</label>
                </div>
                <div className="col-6">
                  <input
                    type="number"
                    className="form-control"
                    value={billingCommission.invoiceCommFlatRate}
                    disabled={isDisabled || !this.props.commissionaccess.edit}
                    onChange={(e) => {
                      this.props.calculateComm(
                        "invoiceCommFlatRate",
                        e.target.value
                      );
                    }}
                  />
                </div>
                <br />
                <br />
                <div className="col-6">
                  <label htmlFor="comHoursRate">{"Hourly Rate "}</label>
                </div>
                <div className="col-6">
                  <input
                    type="number"
                    value={billingCommission.invoiceCommHourlyRate}
                    className="form-control"
                    disabled={isDisabled || !this.props.commissionaccess.edit}
                    onChange={(e) => {
                      this.props.calculateComm(
                        "invoiceCommHourlyRate",
                        e.target.value
                      );
                    }}
                  />
                </div>
                <br />
                <br />
                <div className="col-6">
                  <label htmlFor="billableHours">{"# Hours "}</label>
                </div>
                <div className="col-6">
                  <input
                    className="form-control"
                    type="text"
                    value={billingCommission.invoiceCommHours || "00:00"}
                    disabled
                  />
                </div>
                <br />
                <br />
                <div className="col-6">
                  <label htmlFor="hourlyRate">{"Hourly Commission "}</label>
                </div>
                <div className="col-6">
                  <input
                    type="number"
                    readOnly
                    disabled
                    value={billingCommission.commissionHourlyRate}
                    className="form-control"
                  />
                </div>
                <br />
                <br />
                <div className="col-6">
                  <label htmlFor="commissionPercent">{"Percent "}</label>
                </div>
                <div className="col-6">
                  <input
                    type="number"
                    value={billingCommission.invoiceCommPercentage}
                    className="form-control"
                    disabled={isDisabled || !this.props.commissionaccess.edit}
                    onChange={(e) => {
                      this.props.calculateComm(
                        "invoiceCommPercentage",
                        e.target.value
                      );
                    }}
                  />
                </div>
                <br />
                <br />
                <div className="col-6">
                  <label htmlFor="minPerCall">{"Minimum Pay Per Call "}</label>
                </div>
                <div className="col-6">
                  <input
                    type="number"
                    value={billingCommission.invoiceCommMinPayPerCall}
                    className="form-control"
                    disabled={isDisabled || !this.props.commissionaccess.edit}
                    onChange={(e) => {
                      this.props.calculateComm(
                        "invoiceCommMinPayPerCall",
                        e.target.value
                      );
                    }}
                  />
                </div>
                <br />
                <br />
                <div className="col-6">
                  <label htmlFor="commissionRate">{"Commission Rate "}</label>
                </div>
                <div className="col-6">
                  <input
                    type="number"
                    disabled
                    value={billingCommission.commission}
                    className="form-control"
                  />
                </div>
                <br />
                <br />
              </div>
              <div>
                <button
                  className="btn btn-success"
                  disabled={isDisabled || !this.props.commissionaccess.edit}
                  onClick={(e) => {
                    this.props.saveInvoiceComm();
                    this.setState({ openCommWindow: false });
                  }}
                >
                  Save
                </button>{" "}
                <button
                  className="btn btn-danger"
                  onClick={() => {
                    this.setState({ openCommWindow: false });
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </Modal>
          <EstimateModal
            show={this.state.showEstimate}
            onClose={() => this.setState({ showEstimate: false })}
            onSubmit={({ estimateValue, hourlyCharge }) => {
              // Update labor charge via handleCharge (adjusts totalCharge & balanceAmt)
              this.props.handleCharge("estimatedLabourCharge", hourlyCharge);

              // Set metadata fields directly without affecting totals
              this.props.serviceCallInfoFieldChange(
                "invoiceBilling", "estimatedminuts", estimateValue
              );
              this.props.serviceCallInfoFieldChange(
                "invoiceBilling", "serviceBillableHours", estimateValue
              );
              this.props.serviceCallInfoFieldChange(
                "invoiceBilling", "enbaleRecalculate", 0
              );

              // Store calculated amount in component state so it survives page reloads
              const currentBalance = parseFloat(invoiceBilling?.balanceAmt || 0);
              this.setState({
                showEstimate: false,
                confirmedAmount: currentBalance + hourlyCharge,
              });
            }}
            ratePlanData={ratePlan}
            pickupToDropoffTime={invoiceBilling?.estimatedminuts}
            estimatedLabourCharge={invoiceBilling?.estimatedLabourCharge}
          />
          <ConfirmModal
            show={this.state.showConfirm}
            onClose={() => this.setState({ showConfirm: false })}
            onConfirm={() => {
              // Use balanceAmt displayed on screen - this is the amount the driver should pay
              const amt = this.state.confirmedAmount > 0
                ? this.state.confirmedAmount
                : (parseFloat(invoiceBilling?.balanceAmt) > 0
                    ? parseFloat(invoiceBilling.balanceAmt)
                    : parseFloat(invoiceBilling?.totalCharge || 0));
              console.log("Confirm Payment amount:", amt, "balanceAmt:", invoiceBilling?.balanceAmt, "totalCharge:", invoiceBilling?.totalCharge, "confirmedAmount:", this.state.confirmedAmount);
              this.setState({ showConfirm: false });
              this.props.updateInvoiceBilling(
                invoiceBilling?.estimatedminuts,
                invoiceBilling.invoiceId,
                amt
              );
            }}
          />
          <CancelModal
            show={this.state.showCancel}
            onClose={() => this.setState({ showCancel: false })}
            onCancel={() => {
              this.handleCancel(_invoiceObj.invoiceId);
            }}
          />
        </div>
      </Fragment>
    );
  }
}
export default Billing;